import { IpNames } from "../../../interfaces/interfaces";

/** Channels an agency connects straight onto the client's company rather than its own. */
export const directConnectIps = new Set([IpNames.shopify]);

/** Channels whose OAuth callback returns a list of accounts for the user to pick from. */
export const accountSelectIps = new Set([
  IpNames.googleAds,
  IpNames.googleAnalytics,
  IpNames.metaAds,
  IpNames.amazonAds,
]);
